import { createReducer } from 'reduxsauce';
import { Types } from './actions';

const INITIAL_STATE = {
  loading: false,
  reviewsBannerData: null,
  latestReviews: null,
  pageForLatestReviews: 1,
  pageForLaptopsReviews: 1,
  pageForMobilesReviews: 1,
  pageForCamerasReviews: 1,
  pageForAccessoriesReviews: 1,
  topReviews: null,
  laptops: null,
  mobiles: null,
  cameras: null,
  accessories: null,
  bestOfLaptops: null,
  bestOfMobiles: null,
  bestOfCameras: null,
  bestOfAccessories: null,
  laptopsReviews: null,
  mobilesReviews: null,
  camerasReviews: null,
  accessoriesReviews: null
};

// *************************** Fetch Banner ****************************
const fetchReviewsBannerStart = (state = INITIAL_STATE, action) => {
  return { ...state, loading: true };
};

const fetchReviewsBannerSuccess = (state = INITIAL_STATE, action) => {
  return {
    ...state,
    reviewsBannerData: action.reviewsBannerData,
    loading: false
  };
};

const fetchReviewsBannerFailure = (state = INITIAL_STATE, action) => {
  return { ...state, loading: false };
};
// _____________________________________________________________________

// ************************* Fetch Latest Reviews *************************
const fetchLatestReviewsStart = (state = INITIAL_STATE, action) => {
  return { ...state, loading: true };
};

const fetchLatestReviewsSuccess = (state = INITIAL_STATE, action) => {
  let latestReviews = [];
  if (state.latestReviews === null && action.latestReviews.pageNumber === 1) {
    latestReviews = action.latestReviews.latestReviews;
  } else if (action.latestReviews.pageNumber === 1) {
    latestReviews = [...state.latestReviews];
  } else {
    latestReviews = [
      ...state.latestReviews,
      ...action.latestReviews.latestReviews
    ];
  }

  // console.log('latestReviews: ', latestReviews);
  return {
    ...state,
    latestReviews: latestReviews,
    pageForLatestReviews: state.pageForLatestReviews + 1,
    loading: false
  };
};

const fetchLatestReviewsFailure = (state = INITIAL_STATE, action) => {
  return { ...state, loading: false };
};
// _____________________________________________________________________

// ************************** Fetch Top Reviews ***************************
const fetchTopReviewsStart = (state = INITIAL_STATE, action) => {
  return { ...state, loading: true };
};

const fetchTopReviewsSuccess = (state = INITIAL_STATE, action) => {
  return { ...state, topReviews: action.topReviews, loading: false };
};

const fetchTopReviewsFailure = (state = INITIAL_STATE, action) => {
  return { ...state, loading: false };
};
// _____________________________________________________________________

// ************************** Fetch Laptops ***************************
const fetchLaptopsStart = (state = INITIAL_STATE, action) => {
  return { ...state, loading: true };
};

const fetchLaptopsSuccess = (state = INITIAL_STATE, action) => {
  return { ...state, laptops: action.laptops, loading: false };
};

const fetchLaptopsFailure = (state = INITIAL_STATE, action) => {
  return { ...state, loading: false };
};
// _____________________________________________________________________

// ************************** Fetch Mobiles ***************************
const fetchMobilesStart = (state = INITIAL_STATE, action) => {
  return { ...state, loading: true };
};

const fetchMobilesSuccess = (state = INITIAL_STATE, action) => {
  return { ...state, mobiles: action.mobiles, loading: false };
};

const fetchMobilesFailure = (state = INITIAL_STATE, action) => {
  return { ...state, loading: false };
};
// _____________________________________________________________________

// ************************** Fetch Cameras ***************************
const fetchCamerasStart = (state = INITIAL_STATE, action) => {
  return { ...state, loading: true };
};

const fetchCamerasSuccess = (state = INITIAL_STATE, action) => {
  return { ...state, cameras: action.cameras, loading: false };
};

const fetchCamerasFailure = (state = INITIAL_STATE, action) => {
  return { ...state, loading: false };
};
// _____________________________________________________________________

// ************************** Fetch Accessories ***************************
const fetchAccessoriesStart = (state = INITIAL_STATE, action) => {
  return { ...state, loading: true };
};

const fetchAccessoriesSuccess = (state = INITIAL_STATE, action) => {
  return { ...state, accessories: action.accessories, loading: false };
};

const fetchAccessoriesFailure = (state = INITIAL_STATE, action) => {
  return { ...state, loading: false };
};
// _____________________________________________________________________

// ************************** Fetch Best Of Laptops ***************************
const fetchBestOfLaptopsStart = (state = INITIAL_STATE, action) => {
  return { ...state, loading: true };
};

const fetchBestOfLaptopsSuccess = (state = INITIAL_STATE, action) => {
  return { ...state, bestOfLaptops: action.bestOfLaptops, loading: false };
};

const fetchBestOfLaptopsFailure = (state = INITIAL_STATE, action) => {
  return { ...state, loading: false };
};
// _____________________________________________________________________

// ************************** Fetch Best Of Mobiles ***************************
const fetchBestOfMobilesStart = (state = INITIAL_STATE, action) => {
  return { ...state, loading: true };
};

const fetchBestOfMobilesSuccess = (state = INITIAL_STATE, action) => {
  return { ...state, bestOfMobiles: action.bestOfMobiles, loading: false };
};

const fetchBestOfMobilesFailure = (state = INITIAL_STATE, action) => {
  return { ...state, loading: false };
};
// _____________________________________________________________________

// ************************** Fetch Best Of Cameras ***************************
const fetchBestOfCamerasStart = (state = INITIAL_STATE, action) => {
  return { ...state, loading: true };
};

const fetchBestOfCamerasSuccess = (state = INITIAL_STATE, action) => {
  return { ...state, bestOfCameras: action.bestOfCameras, loading: false };
};

const fetchBestOfCamerasFailure = (state = INITIAL_STATE, action) => {
  return { ...state, loading: false };
};
// _____________________________________________________________________

// ************************** Fetch Best Of Accessories ***************************
const fetchBestOfAccessoriesStart = (state = INITIAL_STATE, action) => {
  return { ...state, loading: true };
};

const fetchBestOfAccessoriesSuccess = (state = INITIAL_STATE, action) => {
  return {
    ...state,
    bestOfAccessories: action.bestOfAccessories,
    loading: false
  };
};

const fetchBestOfAccessoriesFailure = (state = INITIAL_STATE, action) => {
  return { ...state, loading: false };
};
// _____________________________________________________________________

// ************************* Fetch Laptops Reviews *************************
const fetchLaptopsReviewsStart = (state = INITIAL_STATE, action) => {
  return { ...state, loading: true };
};

const fetchLaptopsReviewsSuccess = (state = INITIAL_STATE, action) => {
  let laptopsReviews;
  if (state.laptopsReviews === null && action.laptopsReviews.pageNumber === 1) {
    laptopsReviews = action.laptopsReviews.laptopsReviews;
  } else if (action.laptopsReviews.pageNumber === 1) {
    return;
  } else {
    laptopsReviews = [
      ...state.laptopsReviews,
      ...action.laptopsReviews.laptopsReviews
    ];
  }

  return {
    ...state,
    laptopsReviews: laptopsReviews,
    pageForLaptopsReviews: state.pageForLaptopsReviews + 1,
    loading: false
  };
};

const fetchLaptopsReviewsFailure = (state = INITIAL_STATE, action) => {
  return { ...state, loading: false };
};
// _____________________________________________________________________

// ************************* Fetch Mobiles Reviews *************************
const fetchMobilesReviewsStart = (state = INITIAL_STATE, action) => {
  return { ...state, loading: true };
};

const fetchMobilesReviewsSuccess = (state = INITIAL_STATE, action) => {
  let mobilesReviews;
  if (state.mobilesReviews === null && action.mobilesReviews.pageNumber === 1) {
    mobilesReviews = action.mobilesReviews.mobilesReviews;
  } else if (action.mobilesReviews.pageNumber === 1) {
    return;
  } else {
    mobilesReviews = [
      ...state.mobilesReviews,
      ...action.mobilesReviews.mobilesReviews
    ];
  }

  return {
    ...state,
    mobilesReviews: mobilesReviews,
    pageForMobilesReviews: state.pageForMobilesReviews + 1,
    loading: false
  };
};

const fetchMobilesReviewsFailure = (state = INITIAL_STATE, action) => {
  return { ...state, loading: false };
};
// _____________________________________________________________________

// ************************* Fetch Cameras Reviews *************************
const fetchCamerasReviewsStart = (state = INITIAL_STATE, action) => {
  return { ...state, loading: true };
};

const fetchCamerasReviewsSuccess = (state = INITIAL_STATE, action) => {
  let camerasReviews;
  if (state.camerasReviews === null && action.camerasReviews.pageNumber === 1) {
    camerasReviews = action.camerasReviews.camerasReviews;
  } else if (action.camerasReviews.pageNumber === 1) {
    return;
  } else {
    camerasReviews = [
      ...state.camerasReviews,
      ...action.camerasReviews.camerasReviews
    ];
  }

  return {
    ...state,
    camerasReviews: camerasReviews,
    pageForCamerasReviews: state.pageForCamerasReviews + 1,
    loading: false
  };
};

const fetchCamerasReviewsFailure = (state = INITIAL_STATE, action) => {
  return { ...state, loading: false };
};
// _____________________________________________________________________

// ************************* Fetch Accessories Reviews *************************
const fetchAccessoriesReviewsStart = (state = INITIAL_STATE, action) => {
  return { ...state, loading: true };
};

const fetchAccessoriesReviewsSuccess = (state = INITIAL_STATE, action) => {
  let accessoriesReviews;
  if (
    state.accessoriesReviews === null &&
    action.accessoriesReviews.pageNumber === 1
  ) {
    accessoriesReviews = action.accessoriesReviews.accessoriesReviews;
  } else if (action.accessoriesReviews.pageNumber === 1) {
    return;
  } else {
    accessoriesReviews = [
      ...state.accessoriesReviews,
      ...action.accessoriesReviews.accessoriesReviews
    ];
  }

  return {
    ...state,
    accessoriesReviews: accessoriesReviews,
    pageForAccessoriesReviews: state.pageForAccessoriesReviews + 1,
    loading: false
  };
};

const fetchAccessoriesReviewsFailure = (state = INITIAL_STATE, action) => {
  return { ...state, loading: false };
};
// _____________________________________________________________________

// Define Handlers
const HANDLERS = {
  [Types.FETCH_REVIEWS_BANNER_START]: fetchReviewsBannerStart,
  [Types.FETCH_REVIEWS_BANNER_FAILURE]: fetchReviewsBannerFailure,
  [Types.FETCH_REVIEWS_BANNER_SUCCESS]: fetchReviewsBannerSuccess,

  [Types.FETCH_LATEST_REVIEWS_START]: fetchLatestReviewsStart,
  [Types.FETCH_LATEST_REVIEWS_FAILURE]: fetchLatestReviewsFailure,
  [Types.FETCH_LATEST_REVIEWS_SUCCESS]: fetchLatestReviewsSuccess,

  [Types.FETCH_TOP_REVIEWS_START]: fetchTopReviewsStart,
  [Types.FETCH_TOP_REVIEWS_FAILURE]: fetchTopReviewsFailure,
  [Types.FETCH_TOP_REVIEWS_SUCCESS]: fetchTopReviewsSuccess,

  [Types.FETCH_LAPTOPS_START]: fetchLaptopsStart,
  [Types.FETCH_LAPTOPS_FAILURE]: fetchLaptopsFailure,
  [Types.FETCH_LAPTOPS_SUCCESS]: fetchLaptopsSuccess,

  [Types.FETCH_MOBILES_START]: fetchMobilesStart,
  [Types.FETCH_MOBILES_FAILURE]: fetchMobilesFailure,
  [Types.FETCH_MOBILES_SUCCESS]: fetchMobilesSuccess,

  [Types.FETCH_CAMERAS_START]: fetchCamerasStart,
  [Types.FETCH_CAMERAS_FAILURE]: fetchCamerasFailure,
  [Types.FETCH_CAMERAS_SUCCESS]: fetchCamerasSuccess,

  [Types.FETCH_ACCESSORIES_START]: fetchAccessoriesStart,
  [Types.FETCH_ACCESSORIES_FAILURE]: fetchAccessoriesFailure,
  [Types.FETCH_ACCESSORIES_SUCCESS]: fetchAccessoriesSuccess,

  [Types.FETCH_BEST_OF_LAPTOPS_START]: fetchBestOfLaptopsStart,
  [Types.FETCH_BEST_OF_LAPTOPS_FAILURE]: fetchBestOfLaptopsFailure,
  [Types.FETCH_BEST_OF_LAPTOPS_SUCCESS]: fetchBestOfLaptopsSuccess,

  [Types.FETCH_BEST_OF_MOBILES_START]: fetchBestOfMobilesStart,
  [Types.FETCH_BEST_OF_MOBILES_FAILURE]: fetchBestOfMobilesFailure,
  [Types.FETCH_BEST_OF_MOBILES_SUCCESS]: fetchBestOfMobilesSuccess,

  [Types.FETCH_BEST_OF_CAMERAS_START]: fetchBestOfCamerasStart,
  [Types.FETCH_BEST_OF_CAMERAS_FAILURE]: fetchBestOfCamerasFailure,
  [Types.FETCH_BEST_OF_CAMERAS_SUCCESS]: fetchBestOfCamerasSuccess,

  [Types.FETCH_BEST_OF_ACCESSORIES_START]: fetchBestOfAccessoriesStart,
  [Types.FETCH_BEST_OF_ACCESSORIES_FAILURE]: fetchBestOfAccessoriesFailure,
  [Types.FETCH_BEST_OF_ACCESSORIES_SUCCESS]: fetchBestOfAccessoriesSuccess,

  [Types.FETCH_LAPTOPS_REVIEWS_START]: fetchLaptopsReviewsStart,
  [Types.FETCH_LAPTOPS_REVIEWS_FAILURE]: fetchLaptopsReviewsFailure,
  [Types.FETCH_LAPTOPS_REVIEWS_SUCCESS]: fetchLaptopsReviewsSuccess,

  [Types.FETCH_MOBILES_REVIEWS_START]: fetchMobilesReviewsStart,
  [Types.FETCH_MOBILES_REVIEWS_FAILURE]: fetchMobilesReviewsFailure,
  [Types.FETCH_MOBILES_REVIEWS_SUCCESS]: fetchMobilesReviewsSuccess,

  [Types.FETCH_CAMERAS_REVIEWS_START]: fetchCamerasReviewsStart,
  [Types.FETCH_CAMERAS_REVIEWS_FAILURE]: fetchCamerasReviewsFailure,
  [Types.FETCH_CAMERAS_REVIEWS_SUCCESS]: fetchCamerasReviewsSuccess,

  [Types.FETCH_ACCESSORIES_REVIEWS_START]: fetchAccessoriesReviewsStart,
  [Types.FETCH_ACCESSORIES_REVIEWS_FAILURE]: fetchAccessoriesReviewsFailure,
  [Types.FETCH_ACCESSORIES_REVIEWS_SUCCESS]: fetchAccessoriesReviewsSuccess
};

// Create and Export Reducer
export const reviewsReducer = createReducer(INITIAL_STATE, HANDLERS);
